<template>
  <div
    class="d-flex"
    style="justify-content: center;width: 100%;"
  >
    <span v-if="view" class="action-button view-button" @click="detail">
      {{ viewText || '详情' }}
    </span>
    <el-dropdown trigger="click" @command="command" v-if="!!opts.length">
      <i class="el-icon-arrow-down action-button tool-btn" />

      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="(opt, index) in opts"
          :key="index"
          :icon="opt.icon"
          :command="{ opt: opt, data: row }"
          :divided="opt.divided"
          :disabled="opt.disabled == undefined ? false : !!opt.disabled(row)"
        >
          {{ opt.text }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: 'TableActionButton',
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    row: {
      type: Object,
      default: () => ({}),
    },
    view: {
      type: Boolean,
      default: true,
    },
    viewText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  computed: {
    opts() {
      if (!this.options?.length) return []
      return this.options
        .filter((opt) => (!opt.allow ? true : this.allow(opt.allow)))
        .filter((opt) => (opt.filter ? opt.filter(this.row) : true))
    },
  },
  methods: {
    command(d) {
      console.log(d)
      this.$emit('command', d)
    },
    detail() {
      this.$emit('command', { opt: { menuType: 'detail' }, data: this.row })
    },
  },
}
</script>

<style lang="scss" scoped>
.action-button {
  width: 30px !important;
  height: 30px !important;
  font-size: 18px !important;
  text-align: center;
  line-height: 30px !important;
  cursor: pointer;
  border-radius: 4px;
  background-color: #f8f8f8;
}
.action-button.view-button {
  width: 80px !important;
  font-size: 13px !important;
  min-width: max-content;
}

.action-button:hover {
  color: #007bff !important;
  background-color: #e7f1fe !important;
}
</style>
